import { render } from "./addForm.vue?vue&type=template&id=080ecbe2&scoped=true"
import script from "./addForm.vue?vue&type=script&lang=js"
export * from "./addForm.vue?vue&type=script&lang=js"

import "./addForm.vue?vue&type=style&index=0&id=080ecbe2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080ecbe2"]])

export default __exports__